import _ from 'lodash';

import { TRANSACTION_TYPES, isNumber } from 'helpers/prices';

const { SUBSCRIPTION } = TRANSACTION_TYPES;

export const VOUCHER_EXPENSIVE = 'voucher_expensive';
export const VOUCHER_INCLUDES = 'voucher_included';
export const VOUCHER_NOT_EXIST = 'voucher_not_exist';

// initial promotion item
export const INITIAL_PROMOTION = {
	id: null,
	price: null,
	voucherCode: null,
	voucherMessage: ''
};

const NO_PROMOTION = {
	...INITIAL_PROMOTION,
	voucherMessage: VOUCHER_NOT_EXIST
};

// get promotion available for user
const getAvailablePromotions = ({ promotions, userPromotions }) => {
	return Object.keys(promotions)
		.filter((key) => userPromotions.includes(parseInt(key)))
		.reduce((obj, key) => {
			obj[key] = promotions[key];
			return obj;
		}, {});
};

// create array of promotions objects
// sort promotions by price and return first element
const getFavorablePromotion = (array) => {
	const promotions = Object.entries(array).map(([id, price]) => ({
		...INITIAL_PROMOTION,
		id,
		price
	}));

	return _.sortBy(promotions, 'price')[0];
};

// get the most favorable promotion for user
export const getPromotion = ({ price, promotions, userPromotions, isVoucher }) => {
	const availablePromotions = getAvailablePromotions({
		promotions,
		userPromotions
	});

	let voucherMessage = '';

	const promotion = getFavorablePromotion(availablePromotions);

	const isPromotion = promotion?.price < price;

	if (isVoucher) {
		if (_.isEmpty(availablePromotions)) {
			voucherMessage = VOUCHER_NOT_EXIST;
		} else if (!isPromotion) {
			voucherMessage = VOUCHER_EXPENSIVE;
		}
	}

	return isPromotion ? promotion : { ...INITIAL_PROMOTION, voucherMessage };
};

export const getVoucherPromotion = ({ voucherData, transactionType, userPromotions, payment_methods, isVoucher = true }) => {
	const isSubscription = transactionType === SUBSCRIPTION;

	const prices = voucherData[transactionType];

	const paymentMethod = payment_methods.find((method) => {
		const subscriptionMethod = method.includes(SUBSCRIPTION);
		return isSubscription ? subscriptionMethod : !subscriptionMethod;
	});

	const priceData = prices[paymentMethod];

	if (!paymentMethod || !priceData) {
		return NO_PROMOTION;
	}

	const { price, promotions } = priceData;

	const favorablePromotion = promotions ? getPromotion({ price, promotions, userPromotions, isVoucher }) : NO_PROMOTION;

	return favorablePromotion;
};

export const comparePromotion = (regularPromotion, voucherPromotion, voucherCode) => {
	const hasRegularPrice = isNumber(regularPromotion?.price);
	const hasVoucherPrice = isNumber(voucherPromotion?.price);

	const { voucherMessage } = voucherPromotion;

	if (hasRegularPrice && hasVoucherPrice) {
		if (regularPromotion.price <= voucherPromotion.price) {
			return {
				...regularPromotion,
				voucherMessage: VOUCHER_EXPENSIVE
			};
		}

		return {
			...voucherPromotion,
			voucherCode,
			voucherMessage: VOUCHER_INCLUDES
		};
	} else if (hasRegularPrice && !hasVoucherPrice) {
		return { ...regularPromotion, voucherMessage };
	} else if (!hasRegularPrice && hasVoucherPrice) {
		return {
			...voucherPromotion,
			voucherCode,
			voucherMessage: VOUCHER_INCLUDES
		};
	}

	return {
		...INITIAL_PROMOTION,
		voucherMessage
	};
};
